import { z } from 'zod';
import { getParticipantsWithPastShiftsTableFilterDataSchema, participantWithPastShiftsRowSchema, } from './participantsWithPastShiftsCommonSchema';
const getParticipantsWithPastShiftsByMissionIdParamsSchema = z.object({
    missionId: z.string().uuid(),
    isVolunteerView: z.boolean().optional(),
    filterData: getParticipantsWithPastShiftsTableFilterDataSchema,
    limit: z.number().optional(),
    offset: z.number().optional(),
});
const getParticipantsWithPastShiftsByMissionIdResponseSchema = z.object({
    rows: participantWithPastShiftsRowSchema.array(),
    total: z.number(),
    analytics: z.object({
        totalPendingHours: z.number(),
    }),
});
export const getParticipantsWithPastShiftsByMissionIdFunctionDef = {
    name: 'getParticipantsWithPastShiftsByMissionId',
    requestSchema: getParticipantsWithPastShiftsByMissionIdParamsSchema,
    responseSchema: getParticipantsWithPastShiftsByMissionIdResponseSchema,
};
